<style src="./FormFileInput.scss" lang="scss" scoped></style>
<template>
  <section class="form-file-input">
    <div
      class="drop-zone"
      @dragover="isDragOver"
      @dragenter="isDragOver"
      @dragleave="isDragLeave"
      @dragend="isDragLeave"
      @drop="isDrop"
      :class="{'drop-zone-over': dragOverClass}">

      <label class="input-label">
        <input type="file" class="input-file">
        <h3>Arraste o arquivo aqui</h3>
      </label>
    </div>
  </section>
</template>

<script>
import FileHandle from './FileHandle'

export default {
  name: 'FormFileInput',
  data () {
    return {
      dragOverClass: false
    }
  },
  methods: {
    isDragOver (e) {
      e.preventDefault()
      e.stopPropagation()

      if (!this.dragOverClass) this.dragOverClass = true
    },
    isDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.dragOverClass) this.dragOverClass = false
    },
    isDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      this.readFile(e.dataTransfer.files[0])
    },
    readFile (pFile) {
      FileHandle(pFile)
        .then((result) => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/client/components/new-client/form-file-input/FormFileInput.vue